import React from "react"
import "./styles.scss"
import { Card } from "../../components/Card"
import { Label, SelectInput } from "../../components/Form"
import { Grid } from "../../components/Table"
import { Button, ButtonLoader } from "../../components/Button"
import { FilterModalContent } from "../FarmerScreen"
import { applyFilterList } from "../../core/utils/farmerFilter/filters"

export default function AssistanceGenerateLinkScreen({
  data,
  forms,
  steps,
  questions,
  handleSelectedFarmers,
  handleSelectedSteps,
  handleSelectedGroups,
  groups,
  selectedGroups,
  selectedGroupId,
  selectedSteps,
  selectedFarmers,
  handleSelectedForm,
  selectedFormId,
  sendDataToGenerateLink,
  loadingGenerate,
  assistanceCreated,
  handleCopyLink,
  selectedProject,
  projectOptions,
  handleSelectedProject,
  handleSelectedQuestions,
  selectedQuestions,
  setFilterModalIsOpen,
  filterModalIsOpen,
  tagsProject,
  onChangeFilter,
  filter,
  clearFields,
  resetFields,
  tagsToFilter,
  handleTagsToFilter
}) {
  const columnsProducers = [
    {
      id: "checkbox",
      name: "checkbox",
    },
    {
      id: "name",
      field: "name",
      label: "Produtor",
      width: "500px",
    },
    {
      id: "email",
      field: "email",
      label: "Email",
      width: "300px",
    },
    {
      id: "project",
      field: "project",
      label: "Projeto",
      width: "300px",
    },
  ]

  return (
    <>
      <Card className="assistance-generate-link-container">
        <section className="assistance-generate-link-columns">
          <div className="assistance-generate-link__form-select">
            <Label label="Projeto" />
            <SelectInput
              resetFields={selectedProject}
              handleChange={(e) => handleSelectedProject(e)}
              isClearable={false}
              isSearchable={true}
              options={projectOptions}
              value={selectedProject}
            />
            <Label label="Formulário" />
            <SelectInput
              resetFields={!selectedFormId}
              handleChange={handleSelectedForm}
              isClearable={true}
              isSearchable={true}
              options={forms.map((item) => ({ value: item.id, label: item.title }))}
            />
            <Label label="Etapas" />
            <SelectInput
              handleChange={handleSelectedSteps}
              isClearable={true}
              value={selectedSteps}
              isSearchable={true}
              isDisabled={!selectedFormId}
              isMulti={true}
              options={steps || []}
              resetFields={!selectedFormId || !selectedSteps}
            />
            <Label label="Grupos" />
            <SelectInput
              handleChange={handleSelectedGroups}
              isClearable={true}
              value={selectedGroups}
              isSearchable={true}
              isDisabled={!selectedSteps}
              isMulti={true}
              options={groups}
              resetFields={!selectedFormId || !selectedSteps || !selectedGroupId}
            />
            <Label label="Questões" />
            <SelectInput
              handleChange={handleSelectedQuestions}
              isClearable={true}
              value={selectedQuestions}
              isSearchable={true}
              isDisabled={!selectedSteps}
              isMulti={true}
              options={questions}
              resetFields={!selectedSteps || !selectedSteps}
            />
          </div>
        </section>
        <section className="assistance-generate-link-columns producers-to-generate">
          <>
            <div className="producers-to-generate-table-header">
            <h4>Produtores</h4>
            <Button label="Filtrar" color="orange" handleClick={() => setFilterModalIsOpen(true)} isDisabled={!data?.length} />
            </div>
            <Grid
              columns={columnsProducers}
              rows={!loadingGenerate ? applyFilterList(data, filter, tagsToFilter): []}
              onSelectedRowsChange={handleSelectedFarmers}
              isPaginated={false}
            />
            {!Object.values(assistanceCreated).length ? (
              <div className="assistance-generate-link__button">
                <ButtonLoader
                  handleClick={sendDataToGenerateLink}
                  isDisabled={!selectedFarmers?.length || !selectedQuestions?.length}
                  color="orange"
                  label="Enviar Formulário"
                  loading={loadingGenerate}
                  messageProcess="Enviando Formulário..."
                />
              </div>
            ) : (
              <div className="assistance-generate-link__button">
                <div className="copy-area">
                  <span>{assistanceCreated?.link}</span>
                  <Button
                    handleClick={handleCopyLink}
                    variant="ghost"
                    color="orange"
                    label="Copiar Link"
                  />
                </div>
              </div>
            )}
          </>
        </section>
      </Card>
      {filterModalIsOpen && (
        <FilterModalContent
          modalIsOpen={filterModalIsOpen}
          setModalIsOpen={setFilterModalIsOpen}
          tagsProject={tagsProject}
          onChangeFilter={onChangeFilter}
          handleTagsToFilter={handleTagsToFilter}
          tagsToFilter={tagsToFilter}
          filter={filter}
          clearFields={clearFields}
          resetFields={resetFields}
          isFarmerProfile={false}
        />
      )}
    </>
  )
}
